// import React from "react";

export const countries = [
  { code: "af", name: "Afghanistan" },
  { code: "ala", name: "Aland Islands" },
  { code: "al", name: "Albania" },
  { code: "gba", name: "Alderney" },
  { code: "dz", name: "Algeria" },
  { code: "as", name: "American Samoa" },
  { code: "ad", name: "Andorra" },
  { code: "ao", name: "Angola" },
  { code: "ai", name: "Anguilla" },
  { code: "ag", name: "Antigua and Barbuda" },
  { code: "ar", name: "Argentina" },
  { code: "am", name: "Armenia" },
  { code: "aw", name: "Aruba" },
  { code: "asc", name: "Ascension Island" },
  { code: "au", name: "Australia" },
  { code: "at", name: "Austria" },
  { code: "az", name: "Azerbaijan" },
  { code: "bs", name: "Bahamas" },
  { code: "bh", name: "Bahrain" },
  { code: "bd", name: "Bangladesh" },
  { code: "bb", name: "Barbados" },
  { code: "by", name: "Belarus" },
  { code: "be", name: "Belgium" },
  { code: "bz", name: "Belize" },
  { code: "bj", name: "Benin" },
  { code: "bm", name: "Bermuda" },
  { code: "bt", name: "Bhutan" },
  { code: "bo", name: "Bolivia" },
  { code: "ba", name: "Bosnia and Herzegovina" },
  { code: "bw", name: "Botswana" },
  { code: "br", name: "Brazil" },
  { code: "bg", name: "Bulgaria" },
  { code: "bf", name: "Burkina Faso" },
  { code: "bi", name: "Burundi" },
  { code: "kh", name: "Cambodia" },
  { code: "cm", name: "Cameroon" },
  { code: "ca", name: "Canada" },
  { code: "cv", name: "Cape Verde" },
  { code: "bq", name: "Caribbean Netherlands" },
  { code: "ky", name: "Cayman Islands" },
  { code: "cf", name: "Central African Republic" },
  { code: "td", name: "Chad" },
  { code: "cl", name: "Chile" },
  { code: "cx", name: "Christmas Island" },
  { code: "cc", name: "Cocos (Keeling) Islands" },
  { code: "co", name: "Colombia" },
  { code: "km", name: "Comoros" },
  { code: "zr", name: "Congo, The Democratic Republic Of The" },
  { code: "cg", name: "Congo, The Republic of Congo" },
  { code: "ck", name: "Cook Islands" },
  { code: "cr", name: "Costa Rica" },
  { code: "ci", name: "Cote D'Ivoire" },
  { code: "hr", name: "Croatia (local name: Hrvatska)" },
  { code: "cw", name: "Curacao" },
  { code: "cy", name: "Cyprus" },
  { code: "cz", name: "Czech Republic" },
  { code: "dk", name: "Denmark" },
  { code: "dj", name: "Djibouti" },
  { code: "dm", name: "Dominica" },
  { code: "do", name: "Dominican Republic" },
  { code: "ec", name: "Ecuador" },
  { code: "eg", name: "Egypt" },
  { code: "sv", name: "El Salvador" },
  { code: "gq", name: "Equatorial Guinea" },
  { code: "er", name: "Eritrea" },
  { code: "ee", name: "Estonia" },
  { code: "et", name: "Ethiopia" },
  { code: "fk", name: "Falkland Islands (Malvinas)" },
  { code: "fo", name: "Faroe Islands" },
  { code: "fj", name: "Fiji" },
  { code: "fi", name: "Finland" },
  { code: "fr", name: "France" },
  { code: "gf", name: "French Guiana" },
  { code: "pf", name: "French Polynesia" },
  { code: "ga", name: "Gabon" },
  { code: "gm", name: "Gambia" },
  { code: "ge", name: "Georgia" },
  { code: "de", name: "Germany" },
  { code: "gh", name: "Ghana" },
  { code: "gi", name: "Gibraltar" },
  { code: "gr", name: "Greece" },
  { code: "gl", name: "Greenland" },
  { code: "gd", name: "Grenada" },
  { code: "gp", name: "Guadeloupe" },
  { code: "gu", name: "Guam" },
  { code: "gt", name: "Guatemala" },
  { code: "ggy", name: "Guernsey" },
  { code: "gn", name: "Guinea" },
  { code: "gw", name: "Guinea-Bissau" },
  { code: "gy", name: "Guyana" },
  { code: "ht", name: "Haiti" },
  { code: "hn", name: "Honduras" },
  { code: "hk", name: "Hong Kong,China" },
  { code: "hu", name: "Hungary" },
  { code: "is", name: "Iceland" },
  { code: "in", name: "India" },
  { code: "id", name: "Indonesia" },
  { code: "iq", name: "Iraq" },
  { code: "ie", name: "Ireland" },
  { code: "il", name: "Iran" },
  { code: "it", name: "Italy" },
  { code: "jm", name: "Jamaica" },
  { code: "jp", name: "Japan" },
  { code: "jey", name: "Jersey" },
  { code: "jo", name: "Jordan" },
  { code: "kz", name: "Kazakhstan" },
  { code: "ke", name: "Kenya" },
  { code: "ki", name: "Kiribati" },
  { code: "kr", name: "Korea" },
  { code: "ks", name: "Kosovo" },
  { code: "kw", name: "Kuwait" },
  { code: "kg", name: "Kyrgyzstan" },
  { code: "la", name: "Lao People's Democratic Republic" },
  { code: "lv", name: "Latvia" },
  { code: "lb", name: "Lebanon" },
  { code: "ls", name: "Lesotho" },
  { code: "lr", name: "Liberia" },
  { code: "ly", name: "Libya" },
  { code: "li", name: "Liechtenstein" },
  { code: "lt", name: "Lithuania" },
  { code: "lu", name: "Luxembourg" },
  { code: "mo", name: "Macau,China" },
  { code: "mk", name: "Macedonia" },
  { code: "mg", name: "Madagascar" },
  { code: "mw", name: "Malawi" },
  { code: "my", name: "Malaysia" },
  { code: "mv", name: "Maldives" },
  { code: "ml", name: "Mali" },
  { code: "mt", name: "Malta" },
  { code: "mh", name: "Marshall Islands" },
  { code: "mq", name: "Martinique" },
  { code: "mr", name: "Mauritania" },
  { code: "mu", name: "Mauritius" },
  { code: "yt", name: "Mayotte" },
  { code: "mx", name: "Mexico" },
  { code: "fm", name: "Micronesia" },
  { code: "md", name: "Moldova" },
  { code: "mc", name: "Monaco" },
  { code: "mn", name: "Mongolia" },
  { code: "mne", name: "Montenegro" },
  { code: "ms", name: "Montserrat" },
  { code: "ma", name: "Morocco" },
  { code: "mz", name: "Mozambique" },
  { code: "mm", name: "Myanmar" },
  { code: "na", name: "Namibia" },
  { code: "nr", name: "Nauru" },
  { code: "bn", name: "Negara Brunei Darussalam" },
  { code: "np", name: "Nepal" },
  { code: "nl", name: "Netherlands" },
  { code: "an", name: "Netherlands Antilles" },
  { code: "nc", name: "New Caledonia" },
  { code: "nz", name: "New Zealand" },
  { code: "ni", name: "Nicaragua" },
  { code: "ne", name: "Niger" },
  { code: "ng", name: "Nigeria" },
  { code: "nu", name: "Niue" },
  { code: "nf", name: "Norfolk Island" },
  { code: "mp", name: "Northern Mariana Islands" },
  { code: "no", name: "Norway" },
  { code: "om", name: "Oman" },
  { code: "other", name: "Other Country" },
  { code: "pk", name: "Pakistan" },
  { code: "pw", name: "Palau" },
  { code: "ps", name: "Palestine" },
  { code: "pa", name: "Panama" },
  { code: "pg", name: "Papua New Guinea" },
  { code: "py", name: "Paraguay" },
  { code: "pe", name: "Peru" },
  { code: "ph", name: "Philippines" },
  { code: "pl", name: "Poland" },
  { code: "pt", name: "Portugal" },
  { code: "pr", name: "Puerto Rico" },
  { code: "qa", name: "Qatar" },
  { code: "re", name: "Reunion" },
  { code: "ro", name: "Romania" },
  { code: "ru", name: "Russian Federation" },
  { code: "rw", name: "Rwanda" },
  { code: "blm", name: "Saint Barthelemy" },
  { code: "kn", name: "Saint Kitts and Nevis" },
  { code: "lc", name: "Saint Lucia" },
  { code: "maf", name: "Saint Martin" },
  { code: "vc", name: "Saint Vincent and the Grenadines" },
  { code: "ws", name: "Samoa" },
  { code: "sm", name: "San Marino" },
  { code: "st", name: "Sao Tome and Principe" },
  { code: "sa", name: "Saudi Arabia" },
  { code: "sn", name: "Senegal" },
  { code: "srb", name: "Serbia" },
  { code: "sc", name: "Seychelles" },
  { code: "sl", name: "Sierra Leone" },
  { code: "sg", name: "Singapore" },
  { code: "sx", name: "Sint Maarten (Netherlands)" },
  { code: "sk", name: "Slovakia (Slovak Republic)" },
  { code: "si", name: "Slovenia" },
  { code: "sb", name: "Solomon Islands" },
  { code: "so", name: "Somalia" },
  { code: "za", name: "South Africa" },
  { code: "sgs", name: "South Georgia and the South Sandwich Islands" },
  { code: "ss", name: "South Sudan" },
  { code: "es", name: "Spain" },
  { code: "lk", name: "Sri Lanka" },
  { code: "pm", name: "St. Pierre and Miquelon" },
  { code: "sr", name: "Suriname" },
  { code: "sz", name: "Swaziland" },
  { code: "se", name: "Sweden" },
  { code: "ch", name: "Switzerland" },
  { code: "tw", name: "Taiwan,China" },
  { code: "tj", name: "Tajikistan" },
  { code: "tz", name: "Tanzania" },
  { code: "th", name: "Thailand" },
  { code: "tls", name: "Timor-Leste" },
  { code: "tg", name: "Togo" },
  { code: "to", name: "Tonga" },
  { code: "tt", name: "Trinidad and Tobago" },
  { code: "tn", name: "Tunisia" },
  { code: "tr", name: "Turkey" },
  { code: "tm", name: "Turkmenistan" },
  { code: "tc", name: "Turks and Caicos Islands" },
  { code: "tv", name: "Tuvalu" },
  { code: "ug", name: "Uganda" },
  { code: "ua", name: "Ukraine" },
  { code: "ae", name: "United Arab Emirates" },
  { code: "uk", name: "United Kingdom" },
  { code: "us", name: "United States" },
  { code: "uy", name: "Uruguay" },
  { code: "uz", name: "Uzbekistan" },
  { code: "vu", name: "Vanuatu" },
  { code: "va", name: "Vatican City State (Holy See)" },
  { code: "ve", name: "Venezuela" },
  { code: "vn", name: "Vietnam" },
  { code: "vg", name: "Virgin Islands (British)" },
  { code: "vi", name: "Virgin Islands (U.S.)" },
  { code: "wf", name: "Wallis And Futuna Islands" },
  { code: "ye", name: "Yemen" },
  { code: "zm", name: "Zambia" },
  { code: "eaz", name: "Zanzibar" },
  { code: "zw", name: "Zimbabwe" }
];

export const currency = [
  "USD ( US Dollar )",
  "AFN ( Afghan Afghani )",
  "EUR ( Euro )",
  "ALL ( Albanian Lek )",
  "AOA ( Angolan Kwanza )",
  "XCD ( East Carribean Dollar )",
  "AMD ( Armenian Dram )",
  "AWG ( Aruban Florin )",
  "SHP ( St. Helena Pound )",
  "AUD ( Australian Dollar )",
  "AZN ( Azerbaijan New Manat )",
  "BSD ( Bahamian Dollar )",
  "BHD ( Bahraini Dinar )",
  "BDT ( Bangladeshi Taka )",
  "BYR ( Belarusian Ruble )",
  "BZD ( Belize Dollar )",
  "XOF ( CFA Franc BCEAO )",
  "BMD ( Bermudian Dollar )",
  "BTN ( Bhutan Ngultrum )",
  "BAM ( Bosnian Mark )",
  "BWP ( Botswana Pula )",
  "NOK ( Norwegian Kroner )",
  "BRL ( Brazilian Real )",
  "BND ( Brunei Dollar )",
  "BGN ( Bulgarian Lev )",
  "BIF ( Burundi Franc )",
  "KHR ( Cambodian Riel )",
  "XAF ( CFA Franc BEAC )",
  "CAD ( Canadian Dollar )",
  "CVE ( Cape Verde Escudo )",
  "KYD ( Cayman Islands Dollar )",
  "CLP ( Chilean Peso )",
  "KMF ( Comoros Franc )",
  "CDF ( Congolese Franc )",
  "NZD ( New Zealand Dollar )",
  "CRC ( Costa Rican Colon )",
  "CZK ( Czech Koruna )",
  "DKK ( Danish Krone )",
  "DJF ( Djibouti Franc )",
  "DOP ( Dominican Peso )",
  "EGP ( Egyptian Pound )",
  "SVC ( Salvadoran colón )",
  "ERN ( Eritrean Nakfa )",
  "XPF ( CFP Franc )",
  "NIO ( Nicaraguan Cordoba Oro )",
  "NGN ( Nigerian Naira )",
  "OMR ( Omani Rial )",
  "PKR ( Pakistan Rupee )",
  "PGK ( Papua New Guinea Kina )",
  "PYG ( Paraguay Guarani )",
  "PHP ( Philippine Peso )",
  "PLN ( Polish Zloty )",
  "QAR ( Qatari Rial )",
  "RON ( Romanian New Leu )",
  "RUB ( Russian Rouble )",
  "RWF ( Rwandan Franc )",
  "WST ( Samoan Tala )",
  "STD ( Sao Tome/Principe Dobra )",
  "SAR ( Saudi Riyal )",
  "RSD ( Serbian Dinar )",
  "SCR ( Seychelles Rupee )",
  "SLL ( Sierra Leone Leone )",
  "SGD ( Singapore Dollar )",
  "SBD ( Solomon Islands Dollar )",
  "SOS ( Somali Shilling )",
  "ZAR ( South African Rand )",
  "KRW ( Korean Won )",
  "LKR ( Sri Lanka Rupee )",
  "SRD ( Suriname Dollar )",
  "SZL ( Swaziland Lilangeni )",
  "SEK ( Swedish Krona )",
  "CHF ( Swiss Franc )",
  "TWD ( Taiwan Dollar )",
  "TJS ( Tajikistan Somoni )",
  "TZS ( Tanzanian Shilling )",
  "THB ( Thai Baht )",
  "TOP ( Tongan Pa'anga )",
  "TTD ( Trinidad/Tobago Dollar )",
  "TND ( Tunisian Dinar )",
  "TRY ( Turkish Lira )",
  "TMT ( Turkmenistan New Manat )",
  "UGX ( Uganda Shilling )",
  "UAH ( Ukraine Hryvnia )",
  "AED ( Utd. Arab Emir. Dirham )",
  "GBP ( United Kingdom Pound )",
  "UYU ( Uruguayan Peso )",
  "UZS ( Uzbekistan Som )",
  "VUV ( Vanuatu Vatu )",
  "VEF ( Venezuelan Bolivar Fuerte )",
  "VND ( Vietnamese Dong )",
  "YER ( Yemen Rial )",
  "ZMW ( Zambian Kwacha )",
  "ZWL ( Zimbabwe Dollar )",
  "ETB ( Ethiopian Birr )",
  "FKP ( Falkland Islands Pound )",
  "FJD ( Fiji Dollar )",
  "GMD ( Gambian Dalasi )",
  "GEL ( Georgian Lari )",
  "GHS ( Ghanaian New Cedi )",
  "GIP ( Gibraltar Pound )",
  "GTQ ( Guatemalan Quetzal )",
  "GNF ( Guinea Franc )",
  "GYD ( Guyanan Dollar )",
  "HTG ( Haitian Gourde )",
  "HNL ( Honduran Lempira )",
  "HKD ( Hong Kong Dollar )",
  "HUF ( Hungarian Forint )",
  "ISK ( Iceland Krona )",
  "INR ( Indian Rupee )",
  "IDR ( Indonesian Rupiah )",
  "IQD ( Iraqi Dinar )",
  "IRR ( Iran Rial )",
  "JMD ( Jamaican Dollar )",
  "JPY ( Japanese Yen )",
  "KZT ( Kazakhstan Tenge )",
  "KES ( Kenyan Shilling )",
  "KWD ( Kuwaiti Dinar )",
  "KGS ( Kyrgyzstanian Som )",
  "LAK ( Lao Kip )",
  "LBP ( Lebanese Pound )",
  "LSL ( Lesotho Loti )",
  "LRD ( Liberian Dollar )",
  "LYD ( Libyan Dinar )",
  "MOP ( Macanese pataca )",
  "MKD ( Macedonian Denar )",
  "MWK ( Malawi Kwacha )",
  "MYR ( Malaysian Ringgit )",
  "MVR ( Maldive Rufiyaa )",
  "MUR ( Mauritius Rupee )",
  "MXN ( Mexican peso )",
  "MDL ( Moldovan Leu )",
  "MNT ( Mongolian Tugrik )",
  "MAD ( Moroccan Dirham )",
  "MZN ( Mozambique New Metical )",
  "MMK ( Myanmar Kyat )",
  "NAD ( Namibia Dollar )",
  "NPR ( Nepalese Rupee )",
  "ARS ( Argentine Peso )",
  "PEN ( Peruvian Nuevo Sol )",
  "DZD ( Algerian Dinar )",
  "JOD ( Jordanian Dinar )",
  "BOB ( Bolivian Mvdol )",
  "COP ( Unidad de Valor Real )",
  "BBD ( Barbados Dollar )",
  "PAB ( Panamanian balboa )",
  "HRK ( Croatian kuna )"
];

export const languages = [
  { name: "Persian", value: "fa" },
  { name: "English", value: "en" }
];
